var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.word)?_c('NumberLetterForm',{on:{"submitted":_vm.isSubmit}}):_c('GameRoom',{attrs:{"word":_vm.word},on:{"submitted":_vm.isSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }